export default "__VITE_ASSET__hIQQTCQL__"